











import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class LoadingBlock extends Vue {
  @Prop({ default: '100%' }) private width!: string;
  @Prop({ default: '16px' }) private height!: string;
  @Prop({ default: '0px' }) private marginTop!: string;
  @Prop({ default: '0px' }) private marginBottom!: string;
  @Prop({ default: '0px' }) private marginLeft!: string;
  @Prop({ default: '0px' }) private marginRight!: string;
  @Prop({ default: '8' }) private radius!: number | string;
  @Prop({ default: 'grey' }) private color!: boolean;
}
